import { ReactElement } from 'react'

import { VatExemptionMentionModal } from '@features/invoicingSettings/elements/VatExemptionMentionModal'

import { ModalId } from '../../../../../../../../enums/modalId'
import { useInvoiceSettingsModals } from '../../contexts/invoiceSettingsModalsContext'
import { AutomaticPaymentRemindersModal } from './elements/AutomaticPaymentRemindersModal'
import { LegalGuaranteeOfConformityModal } from './elements/LegalGuaranteeOfConformityModal'
import { LegalMentionsModal } from './elements/LegalMentionsModal'

export const InvoiceSettingsModals = (): ReactElement | null => {
  const { automaticPaymentRemindersModal, legalMentionsModal, vatExemptionMentionModal } = useInvoiceSettingsModals()

  const {
    defaultValues: automaticPaymentRemindersDefaultValues,
    isLoading: isAutomaticPaymentRemindersModalLoading,
    onSubmit: onAutomaticPaymentRemindersModalSubmit,
    variant: automaticPaymentRemindersModalVariant,
  } = automaticPaymentRemindersModal

  const {
    defaultValues: legalMentionsDefaultValues,
    onSubmit: onLegalMentionsModalSubmit,
    variant: legalMentionsModalVariant,
  } = legalMentionsModal

  const {
    defaultValue: vatExemptionMentionDefaultValue,
    isSubmitting: isUpdatingVatExemptionMention,
    onSubmit: onVatExemptionMentionModalSubmit,
  } = vatExemptionMentionModal

  const shouldShowAutomaticPaymentRemindersModal =
    !isAutomaticPaymentRemindersModalLoading && automaticPaymentRemindersDefaultValues

  return (
    <>
      {shouldShowAutomaticPaymentRemindersModal && (
        <AutomaticPaymentRemindersModal
          defaultValues={automaticPaymentRemindersDefaultValues}
          id={ModalId.AutomaticPaymentRemindersModal}
          onSubmit={onAutomaticPaymentRemindersModalSubmit}
          variant={automaticPaymentRemindersModalVariant}
        />
      )}
      <LegalMentionsModal
        defaultValues={legalMentionsDefaultValues}
        id={ModalId.LegalMentionsModal}
        onSubmit={onLegalMentionsModalSubmit}
        variant={legalMentionsModalVariant}
      />
      <LegalGuaranteeOfConformityModal id={ModalId.LegalGuaranteeOfConformityModal} />
      <VatExemptionMentionModal
        defaultValue={vatExemptionMentionDefaultValue}
        id={ModalId.VatExemptionMentionModal}
        isSubmitting={isUpdatingVatExemptionMention}
        onSubmit={onVatExemptionMentionModalSubmit}
      />
    </>
  )
}
